import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import Data from '../../../../data/StateSpecialPowerOfAttorneyToSell.json';
import converter from 'number-to-words';
import {Title, Pronoun, Nationality} from '../../../../model/Helper';
import Loading from '../../../../view/Loading';
import PaperSignatoriesAcknowledgementForPdf from '../../../../model/PaperSignatoriesAcknowledgementForPdf';
import PaperSignatoriesForPdf from '../../../../model/PaperSignatoriesForPdf';
import RequiredData from '../../../../model/RequiredData';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class SpecialPowerOfAttorneyStep5 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
		
		this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
                    RequiredData.property(this.state, this.state.formPath+"/1");
					RequiredData.seller(this.state, this.state.formPath+"/2");
                    RequiredData.representative(this.state, this.state.formPath+"/3");
                    RequiredData.price(this.state, this.state.formPath+"/4");

					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));

		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {
        // Data
        let p = this.state.details.property;
        let s = this.state.details.seller;
        let r = this.state.details.representative;

        let blankLine = "____________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [],
            sellerMaritalStatus = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            sellerCorporationRepresentativePosition = []
        s.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerMaritalStatus[i] = seller.sellerMaritalStatus;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationRepresentativePosition[i] = seller.sellerCorporationRepresentativePosition ? seller.sellerCorporationRepresentativePosition : blankLine;

        });

        let representativeName = (r.name || r.mname || r.lname) ? 
            (r.fname+(r.mname?` ${r.mname}`:"")+(r.lname?` ${r.lname}`:"")+(r.suffix?` ${r.suffix}`:"")): 
            blankLine;
        let representativeNationality = r.nationality ? r.nationality : blankLine;
        let representativeAddress = r.address ? r.address :  blankLine;

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                Number(p.price).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;

        let areaNumber = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
                            Number(p.area).toLocaleString() :
                            blankLine;		
        let areaText = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
                        converter.toWords(p.area) : 
                        blankLine;
           
        let htmlSeller =``;

        for(let i=0; i<=(s.length-1); i++) {

            if(sellerMaritalStatus[i]==="Single"){

                htmlSeller+=`<span>${i>0 && i!==i.length-1?`<span>; </span>`:``} <span class="font-weight-bold text-uppercase">${sellerName[i]}</span>, ${sellerNationality[i]}, of legal age, and with address at ${sellerAddress[i]}</span>`;

            } else {

                htmlSeller+=`<span>${i>0 && i!==i.length-1?`<span>; </span>`:``}<span class="font-weight-bold text-uppercase">${i>0 ? " " : ""}We, SPOUSES</span> <span class="font-weight-bold text-uppercase">${sellerName[i]}</span> and <span class="font-weight-bold text-uppercase">${sellerSpouseName[i]}</span>, ${Nationality(sellerNationality[i], sellerMaritalStatus[i])}, both of legal age, and with address at ${sellerAddress[i]}</span>`;
            }

        }
        htmlSeller+=``;

        let contract_html = `
        <style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css);
        </style>
        <div class="pdf">
            <div class="paper">
                
                <div class="paper-title text-center mb-0">
                    Special Power of Attorney
                </div>
                <div class="paper-title-no-underline text-center font-weight-normal mt-0">(to sell)</div>
                
                <div class="text-uppercase">
                    <div class="my-3">
                        KNOW ALL MEN BY THESE PRESENTS:
                    </div>
                </div>

                <div>
                    <p>
                        ${htmlSeller}, do hereby APPOINT, NAME and CONSTITUTE <span class="font-weight-bold text-uppercase">${representativeName}</span>, <span class="dynamic-data text-capitalize">${representativeNationality}</span>, of legal age, and with address at <span class="dynamic-data text-capitalize">${representativeAddress}</span> to be our true and lawful <em>attorney-in-fact</em>, ${sellerMaritalStatus[0]==="Married" ? `for us and in our name` : `for me and in my name`}, place and stead, to do and perform the following acts, deeds and things, to wit;
                        
                    </p>
                </div>

                <div>
                    <p>
                        To sell, transfer and convey to whosoever buyer, our real property, covered by <span class="dynamic-data text-uppercase">${title}</span> (hereinafter "Subject Real Property"), located at <span class="dynamic-data text-capitalize">${pAddress}</span>, and with an area of <span class="dynamic-data text-uppercase">${areaText} (${areaNumber})</span> square meters, amounting to <span class="dynamic-data text-uppercase">${priceText} PESOS (P${priceNumber})</span> Philippine Currency;
                    </p>
                </div>

                <div>
                    <p>
                        To accept and collect full payment in ${sellerMaritalStatus[0]==="Married" ? `our names` : `my name`}, the proceeds of the sale of the Subject Real Property and sign for the receipt thereof;
                    </p>
                </div>

                <div>
                    <p>
                        To pay any and all unpaid or accrued real property taxes including other taxes and miscellaneous expenses, whichever may be applicable, necessary to effect the registration of the sale and the transfer of title of the Subject Real Property to the buyer;
                    </p>
                </div>

                <div>
                    <p>
                        To engage the services of a licensed real estate broker, a lawyer, a tax professional, and such other professional real estate practitioners, if necessary, to ensure the expeditious and smooth sale of the property, and to pay their respective fees and/or commissions from the proceeds of the sale; and
                    </p>
                </div>

                <div>
                    <p>
                        To do and perform any and all other lawful acts and deeds necessary to undertake the execution and finalization of the sale, transfer, or conveyance of the Subject Real Property.
                    </p>
                </div>

                <div>
                    <p>
                        This Special Power of Attorney shall remain valid, binding and effective unless sooner revoked upon written notice to our attorney-in-fact.
                    </p>
                </div>

                <div>
                    <p>
                        HEREBY GIVING AND GRANTING unto our said attorney-in-fact full power and authority to do whatsoever requisite, necessary or proper to be done, as fully to all intents and purposes, as ${Pronoun("I", s[0].sellerGender, s[0].legalPersonality, s[0].sellerMaritalStatus==="Single"?"seller":"sellers")} might or could lawfully do if personally present, and hereby ratifying and confirming all that our said attorney-in-fact shall do or cause to be done under and by virtue of these presents.
                    </p>
                </div>

                <div>
                    <p>
                        IN WITNESS WHEREOF, ${Pronoun("I", s[0].sellerGender, s[0].legalPersonality, s[0].sellerMaritalStatus==="Single"?"seller":"sellers")} have hereunto set our hands this _______________ in _______________, Philippines.    
                    </p>
                </div>

                <br />

                <div>
                    ${PaperSignatoriesForPdf(s, [])}
                </div>	

            </div> 

            <div class="paper" style="page-break-before: always;">
                <table class="table-even">
                    <tr>
                        <td>
                            <table>
                                <tr><td><div class="pr-25">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
                                <tr><td><div class="text-right">)S.S.</div></td></tr>
                            </table>
                        </td>
                        <td>
                        </td>
                    </tr>
                </table>

                <div class="paper-title text-center">
                    Acknowledgement
                </div>

                <div>
                    <p>
                        BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                    </p>
                </div>

                ${PaperSignatoriesAcknowledgementForPdf(s, [])}

                <div>
                    <p>
                        Known to me and to me known to be the same persons who executed the foregoing Special Power of Attorney consisting of [PAGES] pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                    </p>
                    <p>
                        WITNESS MY HAND AND SEAL in the place and on the date first above written.
                    </p>
                </div>

                <br />
                <br />

                <div class="docno">
                    Doc No. ________; <br />
                    Page No. _______; <br />
                    Book No. _______; <br />
                    Series of 20 ___. <br />
                </div>

            </div>

        </div>`;

        let fn = "special_power_of_attorney_to_sell_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
			title: "Your Special Power of Attorney to Sell Contract is now ready",
			description: "Your FREE custom Special Power of Attorney to Sell is now ready for download"
		}
        
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((5/5)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 5/5</p>
									<Link to={this.state.formPath+"/4"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SpecialPowerOfAttorneyStep5;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/special-power-of-attorney-to-sell/SpecialPowerOfAttorneyToSellStep5.js